import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { NotificationService } from '../notifications/notification.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notifications = inject(NotificationService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const detail = resolveErrorDetail(error);

        console.error('[HTTP ERROR]', {
          method: req.method,
          url: req.url,
          status: error.status,
          detail
        });

        notifyRelevantError(notifications, error, req.url, detail);
      } else {
        console.error('[HTTP ERROR] Errore non previsto', error);
        notifications.error('Errore inatteso nella comunicazione con il server.', {
          title: 'Errore',
          dedupeKey: 'http-unexpected',
          source: 'http',
        });
      }

      return throwError(() => error);
    })
  );
};

function resolveErrorDetail(error: HttpErrorResponse): string {
  if (typeof error.error === 'object' && typeof error.error?.detail === 'string') {
    return error.error.detail;
  }
  if (typeof error.error === 'object' && error.error?.detail && typeof error.error.detail?.message === 'string') {
    return error.error.detail.message;
  }
  if (typeof error.error === 'string' && error.error.trim().length > 0) {
    return error.error;
  }
  return error.message || 'Errore HTTP non gestito';
}

function notifyRelevantError(
  notifications: NotificationService,
  error: HttpErrorResponse,
  requestUrl: string,
  detail: string,
): void {
  if (requestUrl.includes('/auth/refresh') && error.status === 401) {
    return;
  }

  const detailObject = typeof error.error === 'object' && error.error?.detail ? error.error.detail : null;
  if (typeof detailObject === 'object' && detailObject?.code === 'OVERLAP_CONFLICT') {
    notifications.warning(detailObject.message || detail, {
      title: 'Sovrapposizione',
      dedupeKey: `overlap-${requestUrl}`,
      source: 'http',
    });
    return;
  }

  if (error.status === 0 || error.status >= 500) {
    notifications.error(detail, {
      title: 'Errore server',
      dedupeKey: `http-${error.status}-${requestUrl}`,
      source: 'http',
    });
  }
}
